import { render, staticRenderFns } from "./salaryPView.vue?vue&type=template&id=5d43ac42&scoped=true&"
import script from "./salaryPView.vue?vue&type=script&lang=js&"
export * from "./salaryPView.vue?vue&type=script&lang=js&"
import style0 from "./salaryPView.vue?vue&type=style&index=0&id=5d43ac42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d43ac42",
  null
  
)

export default component.exports